export default {
  // Title
  title: "Transaction Quantity Configuration",

  // Checkbox
  includeZero: "Include 0",

  // Error message
  maxValueError: "Maximum value must be greater than minimum value",

  // Buttons
  reset: "Reset",
  confirm: "Confirm",

  // Success message
  saveSuccess: "Save successful",
};
